import React from 'react';
import { getFilterManager } from './helpers';
import { isEmptyFilter } from 'helpers/filterHelper';
import { camelize } from 'helpers/syntaxHelper';
import { capitalize } from 'helpers/helpers';
import { translateBlock } from 'i18n';
import {
    StyFilter,
    StyFilterLegend,
    StyTypography,
} from './SharedStyledComponents';
import { useTranslation } from 'react-i18next';
import { FilterOperations } from 'business/definitions';
import TooltipIconButton from 'components/TooltipIconButton';
import CloseIcon from '@mui/icons-material/Close';

type FilterItemEditProps = {
    filter: DashboardFilterT & WithScopes;
    onFilterValueChange: (
        value: Partial<DashboardFilterT & WithScopes>,
        filterKey: number,
    ) => void;
};

const FilterItemEdit = ({
    filter,
    onFilterValueChange,
}: FilterItemEditProps) => {
    const FilterPickerItem = getFilterManager(filter, false);
    const showClearFilter = !isEmptyFilter(filter);
    const key = camelize(filter.field.replace('.', '_'));
    const filterTitle = capitalize(translateBlock(camelize(filter.field)));
    const { t } = useTranslation();

    const resetFilterMaker = () => async () => {
        if (filter) {
            onFilterValueChange(
                {
                    value: null,
                    valueScale: null,
                    operation:
                        filter.operation === FilterOperations.in_
                            ? filter.operation
                            : FilterOperations.greater,
                },
                filter.key,
            );
        }
    };

    return (
        <StyFilter key={key}>
            <StyFilterLegend hidden={!showClearFilter}>
                <StyTypography
                    sx={{
                        display: !showClearFilter ? 'none' : undefined,
                    }}
                >
                    {filterTitle}
                </StyTypography>
            </StyFilterLegend>

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'right',
                    alignItems: 'center',
                    marginBottom: '2px',
                    width: '100%',
                }}
            >
                <FilterPickerItem
                    filter={filter}
                    setFilter={(
                        updatedProps: Partial<DashboardFilterT & WithScopes>,
                    ) => onFilterValueChange(updatedProps, filter.key)}
                    displayIndex={filter.displayIndex}
                    shouldDebounce
                    isPerimeterFilter
                    isDisabled={false}
                />
                {filter.value && (
                    <TooltipIconButton
                        className="icon-button-filter"
                        tooltip={t('queryPerimeter.clearFilter')}
                        onClick={resetFilterMaker()}
                        icon={
                            <CloseIcon
                                sx={{
                                    fontSize: '1rem',
                                }}
                            />
                        }
                    />
                )}
            </div>
        </StyFilter>
    );
};

export default FilterItemEdit;
